/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getApprovalLevelCreateOptions } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetApprovalLevelCreateOptions(options?: UseQueryOptions) {
  return useQuery({
    queryKey: userQueryKeys.approvalLevelCreateOptions,
    queryFn: () => getApprovalLevelCreateOptions().then((res) => res.data),
    ...options,
  });
}
